// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-B1":"B1_vanlife-roadtrips-B1__cPSg9"};